import { render, staticRenderFns } from "./findSimilarProducts.vue?vue&type=template&id=1b93c903&scoped=true"
import script from "./findSimilarProducts.vue?vue&type=script&lang=js"
export * from "./findSimilarProducts.vue?vue&type=script&lang=js"
import style0 from "./findSimilarProducts.vue?vue&type=style&index=0&id=1b93c903&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b93c903",
  null
  
)

export default component.exports